<template>
    <div class="mx-2 mx-lg-5">
         <div class="card mt-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ $t("headers.guestbooks") }}</h3>
                <router-link
                    v-if="$store.getters.hasGatehousePerm('add_guestbook')"
                    :to="{ name: 'guestbookAddView' }"
                    class="btn btn-sm btn-success me-3 d-inline-flex align-items-center"
                >
                    <icon icon="Plus" class="me-2"></icon>
                    <span class="text-white fs-6 fw-bold">{{ $t("utils.addRecord") }}</span>
                </router-link>
            </div>
            <div class="card-body">
                <table class="table table-striped table-hover table-responsive-md text-center">
                    <thead>
                        <tr>
                            <th>{{ $t("guestbook.name") }}</th>
                            <th>{{ $t("guestbook.company") }}</th>
                            <th>{{ $t("guestbook.from") }}</th>
                            <th>{{ $t("guestbook.to") }}</th>
                            <th>{{ $t("status.status") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="guestbooks.length">
                        <tr
                            v-for="guestbook in paginatedGuestbooks"
                            :key="guestbook.id"
                            class="align-middle"
                        >
                            <td>{{ guestbook.guest_name }}</td>
                            <td>{{ guestbook.company }}</td>
                            <td>
                                <span v-if="guestbook.actual_from">
                                    {{ $d(new Date(guestbook.actual_from), 'short') }}
                                </span>
                                <span v-else-if="guestbook.expected_from">
                                    {{ $d(new Date(guestbook.expected_from), 'short') }}
                                    <span class="fw-bold text-danger">*</span>
                                </span>
                                <span v-else>—</span>
                            </td>
                            <td>{{ guestbook.actual_to ? $d(new Date(guestbook.actual_to), 'short') : "—" }}</td>
                            <td>
                                <div
                                    v-if="$store.getters.hasGatehousePerm('change_status_guestbook') && guestbook.status_name !== 'left'"
                                    class="d-inline-flex align-items-center status_hover"
                                    data-bs-toggle="modal"
                                    data-bs-target="#statusModal"
                                    @click="openStatusModal(guestbook)"
                                    style="cursor: pointer;"
                                >
                                    <icon :icon="guestbook.status_icon" class="status_icon me-1" />
                                    <span>{{ $t("status.guestbook." + guestbook.status_name) }}</span>
                                </div>
                                <div v-else class="d-inline-flex align-items-center">
                                    <icon :icon="guestbook.status_icon" class="status_icon me-1" />
                                    <span>{{ $t("status.guestbook." + guestbook.status_name) }}</span>
                                </div>
                            </td>
                            <td>
                                <button
                                    class="btn btn-primary btn-sm me-2"
                                    @click="goToGuestbookDetail(guestbook.id)"
                                >
                                    <icon icon="Search"></icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="6" class="text-center text-muted py-3">
                                {{ $t("guestbook.notFound") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="guestbooks.length >=5" class="d-flex justify-content-between mx-4">
                    <Paginate
                        :page-count="totalPages"
                        :click-handler="(p) => currentPage = p"
                        :prev-text="'«'"
                        :next-text="'»'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :active-class="'active'"
                        :disabled-class="'disabled'"
                    />
                    <div class="flex-shrink-0">
                        <select v-model="perPage" class="form-select form-select-sm" style="height: 40px;">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="25">20</option>
                            <option :value="50">50</option>
                        </select>
                    </div>
                </div>
            </div>
         </div>
    </div>

    <GuestbookStatusesModal v-if="activeGuestbook" :guestbook="activeGuestbook" />
</template>

<script>
import Icon from '@/components/Icon.vue';
import GuestbookStatusesModal from '@/components/GuestbookStatusesModal.vue';
import Paginate from 'vuejs-paginate-next';

    export default {
        components: {
            Icon,
            GuestbookStatusesModal,
            Paginate,
        },
        data() {
            return {
                guestbooks: [],
                statuses: [],
                activeGuestbook: null,
                currentPage: 1,
                perPage: 10,
            }
        },
        computed: {
            paginatedGuestbooks() {
                const start = (this.currentPage - 1) * this.perPage;
                return this.guestbooks.slice(start, start + this.perPage);
            },
            totalPages() {
                return Math.ceil(this.guestbooks.length / this.perPage);
            }
        },
        created() {
            this.getGuestbook();
            this.getStatuses();
        },
        methods: {
            getStatuses() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/statuses`, {
                    params: {model: "guestbook"}
                })
                .then(response => {
                    this.statuses = response.data;
                })
                .catch(error => {
                    console.error("Error loading statuses", error);
                });
            },
            getGuestbook() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/guestbooks`)
                .then(response => {
                    this.guestbooks = response.data;
                })
                .catch(error => {
                    console.error("Error loading guestbooks", error);
                });
            },
            changeStatus(guestbook) {
                const slug = this.$route.params.slug;
                const guestbookId = guestbook.id;
                const statusId = guestbook.status;
                const url = `/${slug}/guestbooks/${guestbookId}/status/edit`
                const dataPost = { status: statusId}

                this.$store.getters.api.patch(url, dataPost)
                .catch(error => {
                    console.error("Failed to update status", error);
                });
            },
            goToGuestbookDetail(guestbookId) {
                this.$router.push({
                    name: "guestbookDetailView",
                    params: {
                        slug: this.$route.params.slug,
                        id: guestbookId,
                    }
                });
            },
            openStatusModal(guestbook) {
                this.activeGuestbook = guestbook;
            },
        }
    }
</script>

<style scoped>
.status_icon {
    width: 25px;
    height: 25px;
}

table {
    table-layout: fixed;
}
</style>